import {
  MdProductionQuantityLimits,
  MdContentPaste,
  MdOutlineAddLocationAlt,
  MdOutlineCategory,
} from "react-icons/md";
import { BsSliders, BsTable } from "react-icons/bs";
import { SiOpslevel } from "react-icons/si";
import { BiMessageDetail } from "react-icons/bi";

import {
  MdOutlineDashboardCustomize,
  MdOutlineChangeCircle,
  MdManageSearch,
  MdOutlinePlaylistAdd,
  MdOutlineHolidayVillage,
} from "react-icons/md";
import {
  BsLadder,
  BsCalendar2DayFill,
  BsFillPatchQuestionFill,
  BsPatchQuestion,
} from "react-icons/bs";
import { VscLayersActive } from "react-icons/vsc";
import { AiOutlineFileDone, AiOutlineLoading3Quarters } from "react-icons/ai";
import { FaCity, FaExternalLinkSquareAlt } from "react-icons/fa";
import { GiModernCity } from "react-icons/gi";
import {
  MdOutlineLocationCity,
  MdPlace,
  MdContentCopy,
  MdViewQuilt,
  MdCategory,
  MdBrandingWatermark,
  MdTransgender,
} from "react-icons/md";
import { RiQuestionAnswerFill } from "react-icons/ri";
// import { TbBrandSnapchat, TbGenderTransgender } from "react-icons/t";
// import {GrView} from "react-icons/gr";
const BaseContentUnitURL = "/dashboard/content-controller";

const BaseQuestionURL = "/dashboard/content-controller";

export const ContentUnitMenu = [
  {
    name: "داشبورد",
    path: `${BaseContentUnitURL}/dashboard`,
    icon: <MdOutlineDashboardCustomize size={20} />,
    type: "menu",
    child: [`${BaseContentUnitURL}/dashboard`],
  },
  {
    name: "محصولات",
    path: `${BaseContentUnitURL}/products`,
    icon: <MdProductionQuantityLimits size={20} />,
    type: "menu",
    child: [
      `${BaseQuestionURL}/products/addNewProduct`,
      `${BaseContentUnitURL}/products`,
      `${BaseQuestionURL}/products/myProduct`,
      `${BaseQuestionURL}/products/submitedProduct`,
      `${BaseQuestionURL}/products/changeProductStatus`,
      `${BaseQuestionURL}/products/activeProduct`,
      `${BaseQuestionURL}/products/finishedProduct`,
      `${BaseQuestionURL}/products/rockedProduct`,
      `${BaseQuestionURL}/products/addRockedProduct`,
    ],
  },
  {
    name: "مطالب",
    path: `${BaseContentUnitURL}/content`,
    icon: <MdContentPaste size={20} />,
    type: "menu",
    child: [
      `${BaseQuestionURL}/content/add-blog`,
      `${BaseQuestionURL}/content/view-blog`,
      `${BaseQuestionURL}/content/blogCategory`,
      `${BaseContentUnitURL}/content`,
    ],
  },
  {
    name: "اسلایدرها",
    path: `${BaseContentUnitURL}/slider/top-slider`,
    icon: <BsSliders size={20} />,
    type: "menu",
    child: [
      `${BaseContentUnitURL}/slider/top-slider`,
      `${BaseContentUnitURL}/slider/edit-slider`,
    ],
  },
  {
    name: "دسته بندی محصولات",
    path: `${BaseContentUnitURL}/productCategory`,
    icon: <MdOutlineCategory size={20} />,
    type: "menu",
    child: [
      `${BaseContentUnitURL}/productCategory`,
      `${BaseQuestionURL}/productCategory/level1-product-category`,
      `${BaseQuestionURL}/productCategory/level2-product-category`,
      `${BaseQuestionURL}/productCategory/level3-product-category`,
      `${BaseQuestionURL}/productCategory/addBrand`,
      `${BaseQuestionURL}/productCategory/addGender`,
      `${BaseQuestionURL}/productCategory/addOccation`,
      `${BaseQuestionURL}/productCategory/addTextTemplateTable`,
    ],
  },
  {
    name: "ویژگی های محصول",
    path: `${BaseContentUnitURL}/productProperty`,
    icon: <SiOpslevel size={20} />,
    type: "menu",
    child: [
      `${BaseContentUnitURL}/productProperty`,
      `${BaseQuestionURL}/productProperty/level-second`,
      `${BaseQuestionURL}/productProperty/level-first`,
    ],
  },
  {
    name: "سوالات متداول",
    path: `${BaseContentUnitURL}/commonQuestion`,
    icon: <BsPatchQuestion size={20} />,
    type: "menu",
    child: [
      `${BaseContentUnitURL}/commonQuestion`,
      `${BaseQuestionURL}/commonQuestion/add-category-question`,
      `${BaseQuestionURL}/commonQuestion/add-question`,
      `${BaseQuestionURL}/commonQuestion/edit-ask-question`,
    ],
  },
  {
    name: "مناطق تحت پوشش",
    path: `${BaseContentUnitURL}/areasCovered`,
    icon: <MdOutlineAddLocationAlt size={20} />,
    type: "menu",
    child: [
      `${BaseContentUnitURL}/areasCovered`,
      `${BaseQuestionURL}/areasCovered/country`,
      `${BaseQuestionURL}/areasCovered/province`,
      `${BaseQuestionURL}/areasCovered/city`,
      `${BaseQuestionURL}/areasCovered/area`,
    ],
  },
  {
    name: "پیام رسانی",
    path: `${BaseContentUnitURL}/notification`,
    icon: <BiMessageDetail size={20} />,
    type: "menu",
    child: [`${BaseContentUnitURL}/notification`],
  },
  {
    name: "تعطیلات رسمی",
    path: `${BaseContentUnitURL}/officialHoliday`,
    icon: <MdOutlineHolidayVillage size={20} />,
    type: "menu",
    child: [`${BaseContentUnitURL}/officialHoliday`],
  },
];

const BaseProductURL = "/dashboard/content-controller/product";

export const ProductPartsLink = [
  {
    id: "1",
    name: "صندوق",
    path: `${BaseProductURL}/add-product`,
    icon: <MdOutlineDashboardCustomize size={25} />,
    color: "#0062FF",
    type: "menu",
  },
  {
    id: "2",
    name: "صندوق",
    path: `${BaseProductURL}/add-product`,
    icon: <MdOutlineDashboardCustomize size={25} />,
    color: "#E02F87",
    type: "menu",
  },
  {
    id: "3",
    name: "بانک ها",
    path: `${BaseProductURL}/add-product`,
    icon: <MdOutlineDashboardCustomize size={25} />,
    color: "#FF974A",
    type: "menu",
  },
  {
    id: "4",
    name: "چک ها",
    path: `${BaseProductURL}/add-product`,
    icon: <MdOutlineDashboardCustomize size={25} />,
    color: "#13B374",
    type: "menu",
  },
  {
    id: "5",
    name: "چک ها",
    path: `${BaseProductURL}/add-product`,
    icon: <MdOutlineDashboardCustomize size={25} />,
    color: "#13B374",
    type: "menu",
  },
  {
    id: "6",
    name: "چک ها",
    path: `${BaseProductURL}/add-product`,
    icon: <MdOutlineDashboardCustomize size={25} />,
    color: "#13B374",
    type: "menu",
  },
  {
    id: "7",
    name: "چک ها",
    path: `${BaseProductURL}/add-product`,
    icon: <MdOutlineDashboardCustomize size={25} />,
    color: "#13B374",
    type: "menu",
  },
  {
    id: "8",
    name: "چک ها",
    path: `${BaseProductURL}/add-product`,
    icon: <MdOutlineDashboardCustomize size={25} />,
    color: "#13B374",
    type: "menu",
  },
];

export const commonQuestionLink = [
  {
    id: "1",
    name: "دسته بندی سوالات",
    path: `${BaseQuestionURL}/commonQuestion/add-category-question`,
    icon: <BsFillPatchQuestionFill size={25} />,
    color: "#0062FF",
    type: "menu",
  },
  {
    id: "2",
    name: "افزودن سوال",
    path: `${BaseQuestionURL}/commonQuestion/add-question`,
    icon: <RiQuestionAnswerFill size={25} />,
    color: "#0062FF",
    type: "menu",
  },
];

export const contentLinkMenu = [
  {
    id: "1",
    name: "مطلب جدید",
    path: `${BaseQuestionURL}/content/add-blog`,
    icon: <MdContentCopy size={25} />,
    color: "#0062FF",
    type: "menu",
  },
  {
    id: "2",
    name: "مشاهده مطالب",
    path: `${BaseQuestionURL}/content/view-blog`,
    icon: <MdViewQuilt size={25} />,
    color: "#0062FF",
    type: "menu",
  },
  {
    id: "3",
    name: "دسته بندی مطلب",
    path: `${BaseQuestionURL}/content/blogCategory`,
    icon: <MdCategory size={25} />,
    color: "#0062FF",
    type: "menu",
  },
];

export const productPropertyMenu = [
  {
    id: "1",
    name: "سطح اول",
    path: `${BaseQuestionURL}/productProperty/level-first`,
    icon: <FaExternalLinkSquareAlt size={25} />,
    color: "#0062FF",
    type: "menu",
  },
  {
    id: "2",
    name: "سطح دوم",
    path: `${BaseQuestionURL}/productProperty/level-second`,
    icon: <FaExternalLinkSquareAlt size={25} />,
    color: "#0062FF",
    type: "menu",
  },
];

export const AreasCoveredMenu = [
  {
    id: "1",
    name: "کشور ها",
    path: `${BaseQuestionURL}/areasCovered/country`,
    icon: <MdOutlineLocationCity size={25} />,
    color: "#0062FF",
    type: "menu",
  },
  {
    id: "2",
    name: "استان ها",
    path: `${BaseQuestionURL}/areasCovered/province`,
    icon: <GiModernCity size={25} />,
    color: "#0062FF",
    type: "menu",
  },
  {
    id: "3",
    name: "شهر ها",
    path: `${BaseQuestionURL}/areasCovered/city`,
    icon: <FaCity size={25} />,
    color: "#0062FF",
    type: "menu",
  },
  {
    id: "4",
    name: "مناطق",
    path: `${BaseQuestionURL}/areasCovered/area`,
    icon: <MdPlace size={25} />,
    color: "#0062FF",
    type: "menu",
  },
];

// export const inventoryMenu = [
//   {
//     id: "1",
//     name: "کد تخفیف",
//     path: `${BaseQuestionURL}/offCode`,
//     icon: <MdOutlineDashboardCustomize size={25} />,
//     color: "#0062FF",
//     type: "menu",
//   },
//   {
//     id: "2",
//     name: "تخفیف بر اساس دسته بندی یا انبار",
//     path: `${BaseQuestionURL}/offInventory`,
//     icon: <MdOutlineDashboardCustomize size={25} />,
//     color: "#0062FF",
//     type: "menu",
//   },
//   {
//     id: "3",
//     name: "کنترل  قیمت",
//     path: `${BaseQuestionURL}/controllPrice`,
//     icon: <MdOutlineDashboardCustomize size={25} />,
//     color: "#0062FF",
//     type: "menu",
//   },
// ];

export const ProductCategoryLink = [
  {
    id: "1",
    name: "سطح اول",
    path: `${BaseQuestionURL}/productCategory/level1-product-category`,
    icon: <FaExternalLinkSquareAlt size={25} />,
    color: "#0062FF",
    type: "menu",
  },
  {
    id: "2",
    name: "سطح دوم",
    path: `${BaseQuestionURL}/productCategory/level2-product-category`,
    icon: <FaExternalLinkSquareAlt size={25} />,
    color: "#0062FF",
    type: "menu",
  },
  {
    id: "3",
    name: "سطح سوم",
    path: `${BaseQuestionURL}/productCategory/level3-product-category`,
    icon: <FaExternalLinkSquareAlt size={25} />,
    color: "#0062FF",
    type: "menu",
  },
  {
    id: "4",
    name: "افزودن  برند",
    path: `${BaseQuestionURL}/productCategory/addBrand`,
    icon: <MdBrandingWatermark size={25} />,
    color: "#0062FF",
    type: "menu",
  },
  {
    id: "5",
    name: "جنسیت",
    path: `${BaseQuestionURL}/productCategory/addGender`,
    icon: <MdTransgender size={25} />,
    color: "#0062FF",
    type: "menu",
  },
  {
    id: "6",
    name: "مناسبتی",
    path: `${BaseQuestionURL}/productCategory/addOccation`,
    icon: <BsCalendar2DayFill size={25} />,
    color: "#0062FF",
    type: "menu",
  },
  {
    id: "7",
    name: "افزودن جدول کلمات",
    path: `${BaseQuestionURL}/productCategory/addTextTemplateTable`,
    icon: <BsTable size={25} />,
    color: "#0062FF",
    type: "menu",
  },
];

export const ProductLinksMenu = [
  {
    id: "1",
    name: "محصول جدید",
    path: `${BaseQuestionURL}/products/addNewProduct`,
    icon: <MdOutlinePlaylistAdd size={25} />,
    color: "#0062FF",
    type: "menu",
  },
  {
    id: "2",
    name: "محصولات درحال بررسی",
    path: `${BaseQuestionURL}/products/myProduct`,
    icon: <MdManageSearch size={25} />,
    color: "#E02F87",
    type: "menu",
  },
  {
    id: "3",
    name: "محصولات تایید نشده",
    path: `${BaseQuestionURL}/products/submitedProduct`,
    icon: <BsLadder size={25} />,
    color: "#13B374",
    type: "menu",
  },
  {
    id: "4",
    name: "تغییر وضعیت  محصول",
    path: `${BaseQuestionURL}/products/changeProductStatus`,
    icon: <MdOutlineChangeCircle size={25} />,
    color: "#0062FF",
    type: "menu",
  },
  {
    id: "5",
    name: "محصولات فعال",
    path: `${BaseQuestionURL}/products/activeProduct`,
    icon: <VscLayersActive size={25} />,
    color: "#E02F87",
    type: "menu",
  },
  {
    id: "6",
    name: "محصولات تمام شده",
    path: `${BaseQuestionURL}/products/finishedProduct`,
    icon: <AiOutlineFileDone size={25} />,
    color: "#0062FF",
    type: "menu",
  },
  {
    id: "7",
    name: "محصولات راکد",
    path: `${BaseQuestionURL}/products/rockedProduct`,
    icon: <AiOutlineLoading3Quarters size={25} />,
    color: "#13B374",
    type: "menu",
  },
  {
    id: "8",
    name: " راکد کردن محصولات انبار",
    path: `${BaseQuestionURL}/products/addRockedProduct`,
    icon: <AiOutlineLoading3Quarters size={25} />,
    color: "#E02F87",
    type: "menu",
  },
];
